import { render, staticRenderFns } from "./SimpleQuotationModalInfo.vue?vue&type=template&id=7622c505&scoped=true&"
import script from "./SimpleQuotationModalInfo.vue?vue&type=script&lang=js&"
export * from "./SimpleQuotationModalInfo.vue?vue&type=script&lang=js&"
import style0 from "./SimpleQuotationModalInfo.vue?vue&type=style&index=0&id=7622c505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622c505",
  null
  
)

export default component.exports